import React from "react";
import styled from "styled-components";

interface Props {
    children: React.ReactNode
}

export const NavItem: React.FC<Props> = ({ children }) => {
  return (
    <Wrapper>
        {children}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  padding: 8px 14px;
`;